import PropTypes from "prop-types";
import { MdOutlinePhone } from "react-icons/md";
import Button from "shared/components/Button";
import Modal from "shared/components/Modal";

const HelpModal = ({
  visible,
  onClose,
  title,
  description,
  phoneNumber,
  displayPhoneNumber,
  closeLabel,
}) => (
  <Modal
    mode="simple"
    open={visible}
    onCancel={onClose}
    footer={null}
    centered
    className="radiance-help-modal"
    child={
      <div className="radiance-help-modal__body">
        <h3 className="radiance-help-modal__title">{title}</h3>
        <p className="radiance-help-modal__description">{description}</p>
        <div className="radiance-help-modal__action">
          <a href={`tel:${phoneNumber}`}>
            <Button type="primary" onClick={onClose}>
              <MdOutlinePhone size={42} />
              {displayPhoneNumber}
            </Button>
          </a>
        </div>
        <button
          type="button"
          className="radiance-help-modal__close"
          onClick={onClose}
        >
          {closeLabel}
        </button>
      </div>
    }
  />
);

HelpModal.propTypes = {
  visible: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  phoneNumber: PropTypes.string.isRequired,
  displayPhoneNumber: PropTypes.string.isRequired,
  closeLabel: PropTypes.string.isRequired,
};

export default HelpModal;
